export const PACKAGE_PRICES = {
  '2-day': 895,
  '3-day': 999
};

export const PASSENGER_PRICE = 395;
export const PHOTOGRAPHER_PRICE = 495;
export const GOPRO_PRICE = 75;
export const MERCH_PRICE = 45;
export const MAX_MOTORCYCLES = 12;

export const formatPrice = (amount) => amount.toLocaleString('en-US');

export const packageName = (packageId) =>
  packageId === '3-day' ? '3-Day Ultimate' : '2-Day Adventure';

export const calculateQuote = ({
  packageId = '3-day',
  motorcycles = 1,
  passengers = 0,
  photographer = false,
  goproQty = 0,
  merchQty = 0
} = {}) => {
  const bikes = Math.min(MAX_MOTORCYCLES, Math.max(1, Number(motorcycles) || 1));
  const pax = Math.min(bikes, Math.max(0, Number(passengers) || 0));
  const gopros = Math.min(bikes, Math.max(0, Number(goproQty) || 0));
  const merch = Math.min(bikes + pax, Math.max(0, Number(merchQty) || 0));
  const unit = PACKAGE_PRICES[packageId] || PACKAGE_PRICES['3-day'];

  const lines = [
    {
      key: 'bikes',
      label: `${bikes} motorcycle${bikes === 1 ? '' : 's'} × $${formatPrice(unit)}`,
      amount: bikes * unit
    }
  ];

  if (pax > 0) {
    lines.push({
      key: 'passengers',
      label: `${pax} passenger${pax === 1 ? '' : 's'} × $${formatPrice(PASSENGER_PRICE)}`,
      amount: pax * PASSENGER_PRICE
    });
  }

  if (photographer) {
    lines.push({
      key: 'photos',
      label: 'Photographer (one for the group)',
      amount: PHOTOGRAPHER_PRICE
    });
  }

  if (gopros > 0) {
    lines.push({
      key: 'gopro',
      label: `${gopros} GoPro rental${gopros === 1 ? '' : 's'} × $${GOPRO_PRICE}`,
      amount: gopros * GOPRO_PRICE
    });
  }

  if (merch > 0) {
    lines.push({
      key: 'memorabilia',
      label: `${merch} hat and t-shirt${merch === 1 ? '' : 's'} × $${MERCH_PRICE}`,
      amount: merch * MERCH_PRICE
    });
  }

  const total = lines.reduce((sum, line) => sum + line.amount, 0);
  return { bikes, pax, gopros, merch, unit, lines, total };
};
